<ion-header>
  <ion-toolbar class="ion-justify-content-center"
    style="--background: var(--ion-color-toolbar-primary); color: var(--ion-title-color);">
    <ion-title>{{ component.alias }}</ion-title>
    <ion-buttons slot="end">
      <oe-help-button key="CONTROLLER_IO_HEAT_PUMP_SG_READY"></oe-help-button>
      <ion-button (click)="modalCtrl.dismiss()">
        <ion-icon name="close-outline" style="color: var(--ion-title-color);"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container *ngIf="!loading">
    <ion-card-content class="underline">
      <table *ngIf="(edge.currentData | async)['channel'] as currentData" class="full_width">
        <tr [ngSwitch]="currentData[component.id + '/Status']">
          <td style="width:65%" translate>GENERAL.STATE</td>
          <td *ngIf="currentData[this.component.id + '/State'] !== 3" style="width:35%" class="align_right" translate>
            <ng-container *ngSwitchCase="-1">
              EDGE.INDEX.WIDGETS.HEAT_PUMP.UNDEFINED
            </ng-container>
            <ng-container *ngSwitchCase="0">
              EDGE.INDEX.WIDGETS.HEAT_PUMP.LOCK
            </ng-container>
            <ng-container *ngSwitchCase="1">
              EDGE.INDEX.WIDGETS.HEAT_PUMP.NORMAL_OPERATION
            </ng-container>
            <ng-container *ngSwitchCase="2">
              EDGE.INDEX.WIDGETS.HEAT_PUMP.SWITCH_ON_REC
            </ng-container>
            <ng-container *ngSwitchCase="3">
              EDGE.INDEX.WIDGETS.HEAT_PUMP.SWITCH_ON_COM
            </ng-container>
          </td>
          <td *ngIf="currentData[this.component.id + '/State'] === 3" style="width:35%" class="align_right">
            <ion-icon name="help-outline"></ion-icon>
          </td>
        </tr>
        <tr>
          <td style="width:65%" translate>GENERAL.MODE</td>
          <td *ngIf="component.properties['mode'] === 'MANUAL'" style="width: 35%" class="align_right" translate>
            GENERAL.MANUALLY
          </td>
          <td *ngIf="component.properties['mode'] === 'AUTOMATIC'" style="width: 35%" class="align_right" translate>
            GENERAL.AUTOMATIC
          </td>
        </tr>
      </table>
    </ion-card-content>
    <ion-card-content class="underline">
      <table class="full_width">
        <tr>
          <td translate>
            GENERAL.MODE
          </td>
        </tr>
      </table>
      <!-- Controller Mode -->
      <ion-segment (ionChange)="updateControllerMode($event)" [value]="component.properties['mode']" scrollable="false">
        <ion-segment-button value="MANUAL">
          <ion-label>
            {{"GENERAL.MANUALLY" | translate}}
          </ion-label>
          <ion-icon [color]="component.properties['mode'] === 'MANUAL'? 'success': 'normal'" style="width:40px"
            name="options-outline"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="AUTOMATIC">
          <ion-label style="color: var(--ion-color-text)">
            {{"GENERAL.AUTOMATIC" | translate}}
          </ion-label>
          <ion-icon style="width:40px" name="sunny-outline"
            [color]="component.properties['mode'] === 'AUTOMATIC'? 'primary': 'normal'">
          </ion-icon>
        </ion-segment-button>
      </ion-segment>
    </ion-card-content>
    <!-- Manual Mode -->
    <form [formGroup]="formGroup">
      <ng-container *ngIf="component.properties['mode'] === 'MANUAL'">
        <ion-card-content *ngIf="formGroup.value.workMode !== 'NONE'">
          <ion-list>
            <ion-item class="ion-no-padding" style="cursor: pointer;" (click)="updateManualMode('FORCE_ON')"
              lines="none">
              <ion-label class="regularFont">{{"EDGE.INDEX.WIDGETS.HEAT_PUMP.SWITCH_ON_COM" | translate}}</ion-label>
              <ion-toggle (keydown.enter)="updateManualMode('FORCE_ON')" button tabindex="0" mode="md" slot="end"
                style="pointer-events: none" [checked]="formGroup.value.manualState === 'FORCE_ON'">
              </ion-toggle>
            </ion-item>
            <ion-item class="ion-no-padding" style="cursor: pointer;" (click)="updateManualMode('RECOMMENDATION')"
              lines="none">
              <ion-label class="regularFont">{{"EDGE.INDEX.WIDGETS.HEAT_PUMP.SWITCH_ON_REC" | translate}}</ion-label>
              <ion-toggle (keydown.enter)="updateManualMode('RECOMMENDATION')" mode="md" style="pointer-events: none"
                slot="end" [checked]="formGroup.value.manualState === 'RECOMMENDATION'">
              </ion-toggle>
            </ion-item>
            <ion-item class="ion-no-padding" style="cursor: pointer;" (click)="updateManualMode('REGULAR')"
              lines="none">
              <ion-label class="regularFont">{{"EDGE.INDEX.WIDGETS.HEAT_PUMP.NORMAL_OPERATION" | translate}}</ion-label>
              <ion-toggle (keydown.enter)="updateManualMode('REGULAR')" mode="md" style="pointer-events: none"
                slot="end" [checked]="formGroup.value.manualState === 'REGULAR'">
              </ion-toggle>
            </ion-item>
            <ion-item class="ion-no-padding" style="cursor: pointer;" (click)="updateManualMode('LOCK')" lines="none">
              <ion-label class="regularFont">{{"EDGE.INDEX.WIDGETS.HEAT_PUMP.LOCK" | translate}}</ion-label>
              <ion-toggle (keydown.enter)="updateManualMode('LOCK')" mode="md" style="pointer-events: none" slot="end"
                [checked]="formGroup.value.manualState === 'LOCK'"></ion-toggle>
            </ion-item>
          </ion-list>
        </ion-card-content>
      </ng-container>
      <!-- Automatic Mode -->
      <ng-container *ngIf="component.properties['mode'] === 'AUTOMATIC'">
        <ion-card-content class="underline">

          <!-- Switch Togglebutton -->
          <ion-item
            (click)="updateAutomaticEnableMode(formGroup.controls.automaticRecommendationCtrlEnabled.value !== true,'automaticRecommendationCtrlEnabled')"
            class="ion-no-padding" lines="none" style="cursor: pointer;">
            <ion-label class="regularFont">{{"EDGE.INDEX.WIDGETS.HEAT_PUMP.SWITCH_ON_REC" | translate}}</ion-label>
            <ion-toggle mode="md"
              [checked]="formGroup.controls.automaticRecommendationCtrlEnabled.value === true"></ion-toggle>
          </ion-item>

          <table class="full_width">
            <tr>
              <td style="width: 65%" translate>
                EDGE.INDEX.WIDGETS.HEAT_PUMP.GRID_SELL
              </td>
              <td style="width: 35%" class="align_right">
                <ion-item class="ion-no-padding" lines="inset">
                  <ion-input id="automaticRecommendationSurplusPower"
                    formControlName="automaticRecommendationSurplusPower" class="regularFont" type="number"
                    style="text-align: end;" label="&nbsp;W">
                  </ion-input>
                </ion-item>
              </td>
            </tr>
          </table>

          <table class="full_width" *ngIf="formGroup.controls.automaticRecommendationSurplusPower.dirty">
            <tr>
              <td style="width: 100%">
                <ion-text color="danger" translate>
                  EDGE.INDEX.WIDGETS.HEAT_PUMP.MORE_THAN_MAX_POWER
                </ion-text>
              </td>
            </tr>
          </table>
        </ion-card-content>

        <ion-card-content class="underline">
          <ion-item
            (click)="updateAutomaticEnableMode(formGroup.controls.automaticForceOnCtrlEnabled.value !== true,'automaticForceOnCtrlEnabled')"
            class="ion-no-padding" lines="none" style="cursor: pointer;">
            <ion-label class="regularFont">{{"EDGE.INDEX.WIDGETS.HEAT_PUMP.SWITCH_ON_COM" | translate}}
            </ion-label>
            <ion-toggle mode="md"
              [checked]="formGroup.controls.automaticForceOnCtrlEnabled.value === true"></ion-toggle>
          </ion-item>

          <ng-container>
            <table class="full_width">
              <tr>
                <td style="width: 65%" translate>
                  EDGE.INDEX.WIDGETS.HEAT_PUMP.GRID_SELL
                </td>
                <td style="width: 35%" class="align_right">
                  <ion-item class="ion-no-padding" lines="inset">
                    <ion-input type="number" formControlName="automaticForceOnSurplusPower" class="regularFont"
                      style="text-align: end;" label="&nbsp;W">
                    </ion-input>
                  </ion-item>
                </td>
              </tr>
            </table>
            <table class="full_width" *ngIf="formGroup.controls.automaticForceOnSurplusPower.dirty">
              <tr>
                <td style="width: 100%">
                  <ion-text color="danger" translate>
                    EDGE.INDEX.WIDGETS.HEAT_PUMP.MORE_THAN_MAX_POWER
                  </ion-text>
                </td>
              </tr>
            </table>
            <table class="full_width">
              <tr>
                <td style="width: 65%;" translate>
                  EDGE.INDEX.WIDGETS.HEAT_PUMP.ABOVE_SOC</td>
                <td style="width: 35%" class="align_right ion-padding-end">
                  {{ formGroup.controls.automaticForceOnSoc.value | unitvalue:'%' }}
                </td>
              </tr>
            </table>
            <table class="full_width">
              <tr>
                <ion-range formControlName="automaticForceOnSoc" pin color="dark" min="1" max="100">
                  <ion-label slot="start">
                    {{ 0 | unitvalue:'%' }}
                  </ion-label>
                  <ion-label slot="end">
                    {{ 100 | unitvalue:'%' }}
                  </ion-label>
                </ion-range>
              </tr>
            </table>
          </ng-container>
        </ion-card-content>

        <ion-card-content class="underline">
          <ion-item
            (click)="updateAutomaticEnableMode(formGroup.controls.automaticLockCtrlEnabled.value !== true,'automaticLockCtrlEnabled')"
            class="ion-no-padding" lines="none" style="cursor: pointer;">
            <ion-label class="regularFont">{{"EDGE.INDEX.WIDGETS.HEAT_PUMP.LOCK" | translate}}</ion-label>
            <ion-toggle mode="md" [checked]="formGroup.controls.automaticLockCtrlEnabled.value"></ion-toggle>
          </ion-item>
          <ng-container>
            <table class="full_width">
              <tr>
                <td style="width: 65%" translate>
                  EDGE.INDEX.WIDGETS.HEAT_PUMP.GRID_BUY
                </td>
                <td style="width: 35%" class="align_right">
                  <ion-item class="ion-no-padding" lines="inset">
                    <ion-input type="number" formControlName="automaticLockGridBuyPower" class="regularFont"
                      style="text-align: end;" label="&nbsp;W">
                    </ion-input>
                  </ion-item>
                </td>
              </tr>
            </table>
            <table class="full_width">
              <tr>
                <td style="width: 65%;" translate>
                  EDGE.INDEX.WIDGETS.HEAT_PUMP.BELOW_SOC</td>
                <td style="width: 35%" class="align_right ion-padding-end">
                  {{ formGroup.controls.automaticLockSoc.value | unitvalue:'%' }}
                </td>
              </tr>
            </table>
            <table class="full_width">
              <tr>
                <ion-range formControlName="automaticLockSoc" pin color="dark" min="1" max="100">
                  <ion-label slot="start">
                    {{ 0 | unitvalue:'%' }}
                  </ion-label>
                  <ion-label slot="end">
                    {{ 100 | unitvalue:'%' }}
                  </ion-label>
                </ion-range>
              </tr>
            </table>
          </ng-container>
        </ion-card-content>
        <ion-card-content class="underline">
          <table class="full_width">
            <tr>
              <td style="width: 65%" translate>
                EDGE.INDEX.WIDGETS.SINGLETHRESHOLD.MIN_SWITCHING_TIME
              </td>
              <td style="width: 35%" class="align_right">
                <ion-item lines="inset" class="ion-no-padding">
                  <ion-input formControlName="minimumSwitchingTime" class="regularFont" type="number"
                    style="text-align: end;" label="&nbsp;s" class="regularFont">
                  </ion-input>
                </ion-item>
              </td>
            </tr>
          </table>
        </ion-card-content>
      </ng-container>
    </form>


    <ion-fab *ngIf="formGroup.dirty" class="ion-padding-bottom" vertical="bottom" horizontal="center" slot="fixed">
      <ion-fab-button (click)="applyChanges()">
        <ion-icon size="large" name="oe-checkmark">
        </ion-icon>
      </ion-fab-button>
    </ion-fab>
    <ion-grid *ngIf="loading === true">
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </ion-grid>
  </ng-container>
</ion-content>
